import axiosInstance from "../api/axiosInstance";

const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.detail ||
  error?.message ||
  "Unable to hold the booking slot right now.";

const getErrorStatus = (error) => error?.response?.status || 0;

const isPlainObject = (value) =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

export const normalizeBookingActionPayload = (payload) => {
  if (!isPlainObject(payload)) {
    return payload || {};
  }

  const nestedData = isPlainObject(payload.data) ? payload.data : null;
  return nestedData ? { ...payload, ...nestedData } : payload;
};

export const normalizeBookingsPayload = (payload) => {
  const data = isPlainObject(payload?.data) ? payload.data : payload;
  const upcoming = Array.isArray(data?.upcoming) ? data.upcoming : [];
  const past = Array.isArray(data?.past) ? data.past : [];
  const summary = isPlainObject(data?.summary) ? data.summary : {};

  return {
    summary: {
      upcoming: Number(summary?.upcoming) || upcoming.length,
      past: Number(summary?.past) || past.length,
      total: Number(summary?.total) || upcoming.length + past.length,
    },
    upcoming,
    past,
  };
};

export const bookingService = {
  getBookings: async () => {
    try {
      const response = await axiosInstance.get("api/bookings/");
      return normalizeBookingsPayload(response.data);
    } catch (error) {
      const normalizedError = new Error(
        error?.response?.data?.message ||
          error?.response?.data?.detail ||
          error?.message ||
          "Unable to fetch bookings right now."
      );
      normalizedError.status = getErrorStatus(error);
      normalizedError.raw = error?.response?.data || null;
      throw normalizedError;
    }
  },
  holdBooking: async (payload) => {
    try {
      const response = await axiosInstance.post("api/bookings/hold/", payload);
      return normalizeBookingActionPayload(response.data);
    } catch (error) {
      const normalizedError = new Error(getErrorMessage(error));
      normalizedError.status = getErrorStatus(error);
      normalizedError.raw = error?.response?.data || null;
      throw normalizedError;
    }
  },
  createCheckoutSession: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "api/bookings/checkout-session/",
        payload
      );
      return normalizeBookingActionPayload(response.data);
    } catch (error) {
      const normalizedError = new Error(getErrorMessage(error));
      normalizedError.status = getErrorStatus(error);
      normalizedError.raw = error?.response?.data || null;
      throw normalizedError;
    }
  },
  confirmBooking: async (payload) => {
    try {
      const response = await axiosInstance.post("api/bookings/confirm/", payload);
      return normalizeBookingActionPayload(response.data);
    } catch (error) {
      const normalizedError = new Error(getErrorMessage(error));
      normalizedError.status = getErrorStatus(error);
      normalizedError.raw = error?.response?.data || null;
      throw normalizedError;
    }
  },
};
